<template>
	<v-container>
		<v-card class="p-2 pl-2" flat>
			<v-row v-if="!userProfile">
				<v-col cols="12">
					<v-skeleton-loader type="card"></v-skeleton-loader>
				</v-col>
			</v-row>
			<template>
				<v-row justify="start">
					<v-col cols="12">
						<v-simple-table dense height="300px">
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left minwidthtabla">
											Creado
										</th>
										<th class="text-left">
											Nombre
										</th>
										<th class="text-left">
											Apellido
										</th>
										<th class="text-left">
											Celular
										</th>
										<th class="text-left">
											Correo
										</th>

										<th class="text-left">
											Compañia
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="user in users" :key="user.name">
										<td>{{ getCreated(user._id) }}</td>
										<td>{{ user.name }}</td>
										<td>{{ user.lastName }}</td>
										<td>{{ user.phone }}</td>
										<td>{{ user.email }}</td>
										<td>{{ user.company }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
				<v-row justify="start">
					<v-col cols="12" sm="6" md="4" offset-sm="3" offset-md="4">
						<AutocompleteUsers :set-user="setUser" :cleaning="cleaning" />
					</v-col>
				</v-row>
				<v-row v-if="Boolean(user)">
					<v-col cols="12" class="text-center">
						<v-card outlined>
							<v-card-text>
								<v-menu
									v-model="menu"
									:close-on-content-click="false"
									max-width="290"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											clearable
											dense
											outlined
											filled
											label="Seleccione un mes para ver las notificaciones enviadas"
											readonly
											v-bind="attrs"
											v-on="on"
											@click:clear="month = null"
											hide-details
											:value="dateFormatted()"
										></v-text-field>
									</template>
									<v-date-picker
										v-model="month"
										@change="menu = false"
										no-title
										type="month"
										locale="es"
									></v-date-picker>
								</v-menu>
							</v-card-text>
							<v-card-text>
								Notificaciones enviadas en {{ dateFormatted(true) }}:
								{{ monthNotifications }}
							</v-card-text>
						</v-card>
					</v-col>
					<v-col cols="10" sm="6" md="4" @click="selectedCard(0)">
						<AutocompletePersons
							:id="user._id"
							:selected="selected"
							:set-person="setItemPerson"
						/>
					</v-col>
					<v-col cols="10" sm="6" md="4" @click="selectedCard(1)">
						<AutocompletePlaces
							:id="user._id"
							:selected="selected"
							:set-place="setItemPlace"
						/>
					</v-col>
					<v-col cols="10" sm="6" md="4" @click="selectedCard(2)">
						<AutocompleteInvoice
							:id="user._id"
							:selected="selected"
							:set-invoice="setItemInvoice"
						/>
					</v-col>
					<v-row v-if="Boolean(user)" justify="center">
						<v-col cols="8">
							<person-card
								v-show="selected === 0 && itemPerson.firstName"
								:id="user._id"
								:item="itemPerson"
								:cleaning="cleaning"
							/>
							<place-card
								v-show="selected === 1 && itemPlace.name"
								:id="user._id"
								:cleaning="cleaning"
								:item="itemPlace"
							/>
							<invoice-card
								v-show="selected === 2 && itemInvoice.month"
								:id="user._id"
								:item="itemInvoice"
								:cleaning="cleaning"
							/>
						</v-col>
					</v-row>
				</v-row>
			</template>
		</v-card>
	</v-container>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
	name: 'Dashboard',
	components: {
		AutocompleteInvoice: () => import('@/components/dashboard/AutocompleteInvoice'),
		AutocompletePersons: () => import('@/components/dashboard/AutocompletePersons'),
		AutocompleteUsers: () => import('@/components/dashboard/AutocompleteUsers'),
		AutocompletePlaces: () => import('@/components/dashboard/AutocompletePlaces'),
		PersonCard: () => import('@/components/dashboard/PersonCard'),
		PlaceCard: () => import('@/components/dashboard/PlaceCard'),
		InvoiceCard: () => import('@/components/dashboard/InvoiceCard'),
	},
	data() {
		return {
			selected: null,
			user: null,
			itemPerson: {},
			itemPlace: {},
			itemInvoice: {},
			menu: false,
			month: moment()
				.date(1)
				.format('YYYY-MM'),
		};
	},
	computed: {
		...mapGetters({
			users: 'User/users',
		}),
		monthNotifications() {
			const monthNotifications = this.user.notifications.filter(notification => {
				let today;
				if (this.month) {
					today = moment(this.month);
				} else today = moment();
				if (today.isSame(notification.date, 'month')) return notification;
			});
			return monthNotifications.length;
		},
	},
	methods: {
		getCreated(id) {
			const createAt = new Date(parseInt(id.toString().slice(0, 8), 16) * 1000);
			return moment(createAt).format('lll');
		},
		dateFormatted(onlyMonth = false) {
			if (onlyMonth) return this.month ? moment(this.month).format('MMMM') : '';
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
		setUser(value) {
			this.user = value;
		},
		setItemPerson(value) {
			if (value) {
				this.itemPerson = value;
			}
		},
		setItemPlace(value) {
			if (value) {
				this.itemPlace = value;
			}
		},
		setItemInvoice(value) {
			if (value) {
				this.itemInvoice = value;
			}
		},
		selectedCard(value) {
			if (value === 0) {
				this.selected = 0;
				this.itemInvoice = { status: true };
				this.itemPlace = { status: true };
			} else if (value === 1) {
				this.selected = 1;
				this.itemInvoice = { status: true };
				this.itemPerson = {};
			} else if (value === 2) {
				this.selected = 2;
				this.itemPerson = {};
				this.itemPlace = { status: true };
			}
		},
		cleaning() {
			this.itemPerson = { status: true };
			this.itemPlace = { status: true };
			this.itemInvoice = { status: true };
		},
	},
};
</script>

<style media="screen">
.minwidthtabla {
	min-width: 250px !important;
}
</style>
